import React, { useEffect, useState } from "react";
import { useParams } from "react-router";
import { Button } from "reactstrap";
import HoverImage from "react-hover-image/build";

import useAxios from "hooks/useAxios";
import Drawer from "components/Drawer";
import commonColumns, {
  dateFormate,
  currencyFormat,
  cellRendererCheck,
} from "utils/columns";
import FaxSentIcon from "assets/icon/faxSent.svg";
import FaxSentIconHover from "assets/icon/faxSent-hover.svg";
import Comments from "../../../../common/Comments";
import ErrorBoundary from "components/ErrorBoundary";
import ReactStrapTable from "components/reactStrapTable";
import FaxReceivedIcon from "assets/icon/faxReceived.svg";
import AttachIcon from "assets/icon/icon-icon-options-attachment.svg";
import AttachHoverIcon from "assets/icon/icon-icon-options-attachment_hover.svg";
import FaxReceivedIconHover from "assets/icon/FaxReceivedIcon-Hover.svg";
import { cloneDeep } from "lodash";
import ToolTip from "react-tooltip-lite";
import FaxViewer from "components/FaxViewer";

const HistoricalClaims = (props) => {
  const API = useAxios();
  let initialFilters = {
    currentPage: 1,
    pageSize: 10,
    orderBy: "patientFirstName",
    order: "desc",
    filters: [],
  };
  const { refresh, orgId, tenantID, patientId, coveredEntity } = props
  // const { patientId, tenantID } = useParams();
  const [data, setData] = useState([]);
  const [totalSize, setTotalSize] = useState(0);
  const [initFilter, setInitFilter] = useState(initialFilters);
  const [isOpen, setOpen] = useState(false);
  const [claim, setClaim] = useState({});
  const [pdfModal, setPdfModel] = useState(false);
  const [fax, setFaxDetail] = useState({});
  const [selectedTenentID, setSelectedTenentID] = useState({});

  const fetchHistoricalClaims = async (filters = {}) => {
    try {
      const { data } = await API.post(
        `/${tenantID}/Claim/Historical/${parseInt(patientId)}`,
        filters
      );
      if (data) {
        setData(data.items);
        setTotalSize(data.totalRecords);
      }
      else {
        setData([])
        setTotalSize(0);
      }
    } catch (error) { }
  };

  useEffect(() => {
    fetchHistoricalClaims(initialFilters);

    setSelectedTenentID({ tenantID: tenantID });
  }, [refresh]);

  const formatter = (row, columnName) => {
    return <>{row[columnName] || "-"}</>;
  };
  useEffect(() => {
    if (isOpen == true) {
      setOpen(false)
    }
    if (pdfModal == true) {
      setPdfModel(false)
    }

  }, [orgId])
  const toolTipFormatter = (row) => {
    const {
      patientFirstName,
      ndc,
      drugName,
      qtyDispensed,
      providerFirstName,
      providerLastName,
      providerSpecialty,
      dateRXWritten,
      totalPaid,
      dispensingFee,
      ceReceivable,
      drugCost340B,
      profitLoss,
      dateofService,
      providerComments,
    } = row;
    return (
      <ToolTip
        content={
          <div className="tip-list-info">
            <p>
              NDC <span> {ndc} </span>
            </p>
            <p>
              Drug Name<span> {drugName} </span>
            </p>
            <p>
              Dispensed Qty <span> {qtyDispensed} </span>
            </p>
            <p>
              Date Rx Written <span> {dateFormate(dateRXWritten)} </span>
            </p>
            <p>
              Date of Service <span> {dateFormate(dateofService)} </span>
            </p>
            <p>
              Total Paid <span> {currencyFormat(totalPaid)} </span>
            </p>
            <p>
              Dispensing Fee <span> {currencyFormat(dispensingFee)} </span>
            </p>
            <p>
              CE Receivable <span> {currencyFormat(ceReceivable)} </span>
            </p>
            <p>
              340B Drug Cost <span> {currencyFormat(drugCost340B)} </span>
            </p>
            <p>
              Profit/Loss <span> {currencyFormat(profitLoss)} </span>
            </p>
            <p>
              Provider Name{" "}
              <span> {providerFirstName + " " + providerLastName} </span>
            </p>
            <p>
              Provider Specialty<span> {providerSpecialty} </span>
            </p>
            <p>
              Provider Comments{" "}
              <span> {cellRendererCheck(providerComments)} </span>
            </p>
          </div>
        }
        direction="down"
        tagName="span"
        className="target"
        tipContentClassName=""
      >
        <span>{patientFirstName}</span>
      </ToolTip>
    );
  };

  let copyCommonColumns = cloneDeep(commonColumns);
  // var patientObj = {
  //   dataField: "patientFirstName",
  //   text: "Patient First Name",
  //   cellRenderer: (rowData) => toolTipFormatter(rowData),
  //   sort: true,
  //   width: 144,
  //   show: true,
  //   inputType: "text",
  // };

  // copyCommonColumns.splice(0, 1, patientObj);

  const columns = [
    {
      dataField: "attachement",
      text: "Options",
      cellRenderer: (rowData) => attachFile(rowData),
      width: 100,
      show: true,
      disabled: true,
      hideColFilter: true,
      action: true,
      sort: false
    },
    // {
    //   dataField: "patientFirstName",
    //   text: "Patient First Name",
    //   cellRenderer: (rowData) => toolTipFormatter(rowData),
    //   sort: true,
    //   width: 144,
    //   show: true,
    //   inputType: "text",
    // },

    ...copyCommonColumns,
  ];

  columns.splice(8, 1);

  const attachFile = (claim) => {
    return (
      <div className="d-flex align-items-center">
        <Button
          className="text-primary p-0 text-decoration-none"
          color="link"
          onClick={() => toggleDrawer(claim)}
        >
          <HoverImage src={AttachIcon} hoverSrc={AttachHoverIcon} alt="" />
        </Button>
        {claim.isFaxSent && (
          <div className="0">
            <Button
              className="text-primary p-0 text-decoration-none"
              color="link"
              onClick={() => previewFaxInfo(claim, "outboundfax")}
            >
              <HoverImage
                key="FaxSentIcon"
                src={FaxSentIcon}
                hoverSrc={FaxSentIconHover}
                alt=""
              />
            </Button>
            {/* <img src={FaxSentIcon} alt='fax sent' />*/}
          </div>
        )}
        {claim.isFaxReceived && (
          <div className="p-0 ms-0">
            <Button
              className="text-primary p-0 text-decoration-none"
              color="link"
              onClick={() => previewFaxInfo(claim, "inboundfax")}
            >
              <HoverImage
                key="FaxReceivedIcon"
                src={FaxReceivedIcon}
                hoverSrc={FaxReceivedIconHover}
                alt=""
              />
            </Button>
            {/*<img src={FaxReceivedIcon} alt='fax sent' />*/}
          </div>
        )}
      </div>
    );
  };

  const previewFaxInfo = async (row, faxdirection) => {
    try {
      let payload = {};
      payload.FaxDetailID =
        faxdirection === "outboundfax"
          ? row.outboundLastFaxId
          : row.inboundLastFaxId;
      const result = await API.post(
        `/${tenantID}/fax/patientfaxinfo/${row.coveredEntityID}`,
        payload
      );
      if (result) {
        setPdfModel(!pdfModal);
        setFaxDetail(result.data);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const togglePdfModal = () => {
    setPdfModel(!pdfModal);
  };

  const toggleDrawer = (claim) => {
    setClaim(claim);
    setOpen(!isOpen);
  };

  function onPageChange(filter, hasColFilter, colChangedFilter) {
    if (hasColFilter) {
      let combine = { ...filter, filters: [...colChangedFilter] };
      fetchHistoricalClaims(combine, true);
      setInitFilter(combine);
    } else {
      fetchHistoricalClaims(filter);
      setInitFilter(filter);
    }
  }



  const handleSearchColumnFilters = (columnFilters) => {
    if (columnFilters.length) {
      let filter = {
        ...initFilter,
        filters: [...columnFilters],
        currentPage: 1,
      };
      fetchHistoricalClaims(filter, true);
      setInitFilter(filter);
    }
  };

  const handleFilterCancel = () => {
    const filter = { ...initialFilters, pageSize: initFilter.pageSize, order: initFilter.order, orderBy: initFilter.orderBy };
    setInitFilter(filter);
    fetchHistoricalClaims(filter);
  };

  const onPageSizeChange = (filter, hasColFilter, colChangedFilter) => {
    if (hasColFilter) {
      let combine = { ...filter, filters: colChangedFilter };
      fetchHistoricalClaims(combine, true);
      setInitFilter(combine);
    } else {
      fetchHistoricalClaims(filter);
      setInitFilter(filter);
    }
  };

  // const onHandleSort = (filter, hasColFilter) => {
  //   if (hasColFilter) {
  //     fetchHistoricalClaims(filter , true);
  //   } else {
  //     fetchHistoricalClaims(filter);
  //   }
  // };

  const onHandleSort = (filter) => {

    setInitFilter(filter);
    fetchHistoricalClaims(filter);
  };

  return (
    <div
      className="table-card scroll-table position-relative border-0"
      fixed-height={data.length > 0 ? "fixed-height" : "default"}
    >

      <ReactStrapTable
        id="historical-claims"
        height={50 * data.length}
        fixedColumn
        width={1200}
        columns={columns}
        data={data}
        handleSort={onHandleSort}
        loader
        onSearchColumnFilters={handleSearchColumnFilters}
        onFilterCancel={handleFilterCancel}
        hasPagination
        pageSize={initFilter.pageSize}
        onPageSizeChange={onPageSizeChange}
        currentPage={initFilter.currentPage}
        totalRecords={totalSize}
        onPageChange={onPageChange}
        filters={initFilter}
      // datafilter={true}
      ></ReactStrapTable>
      <Drawer
        direction="end"
        isOpen={isOpen}
        toggle={toggleDrawer}
        title="Claim Comments"
        size="lg"
      >
        <ErrorBoundary>
          <Comments
            hasEditable={false}
            rxNumber={claim.rxNumber}
            claimData={claim}
            onClose={toggleDrawer}
            tenantID={tenantID}
            patientId={patientId}
            coveredEntityID={coveredEntity}
          />
        </ErrorBoundary>
      </Drawer>

      <Drawer
        direction="end"
        isOpen={pdfModal}
        toggle={togglePdfModal}
        title="Fax View"
        size="lg"
      >
        <FaxViewer
          selectedCoveredEntity={selectedTenentID}
          hasReadOnly={true}
          hideComments={true}
          toggle={togglePdfModal}
          fax={fax}
        ></FaxViewer>
      </Drawer>

      {/* <FaxViewer
        fax={fax}
        hasReadOnly={true}
        isOpen={pdfModal}
        toggle={togglePdfModal}
        selectedCoveredEntity={selectedTenentID}
        hideComments={true}
      /> */}
    </div>
  );
};

export default HistoricalClaims;
